// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"hQ-z","categoryName":"iQ-z","categoryNameSearchHeader":"jQ-z","categoryContent":"kQ-z","bottomAligned":"lQ-z","image":"mQ-z","imageNoBackground":"nQ-z"};